import React from 'react';
import { useI18n } from '../i18n';

/**
 * Selector de idioma (ES/EN y cualquier idioma registrado en LANGUAGES).
 * Nativo <select> para no depender de UI libs; se puede estilar donde se use.
 */
export default function LanguageSwitcher({ className = '' }) {
  const { lang, setLang, languages } = useI18n();
  return (
    <select
      aria-label="Idioma / Language"
      value={lang}
      onChange={(e) => setLang(e.target.value)}
      className={className}
      style={{
        fontSize: 12, padding: '2px 6px', borderRadius: 6,
        border: '1px solid rgba(148,163,184,0.4)', background: 'transparent',
        color: 'inherit', cursor: 'pointer',
      }}
    >
      {Object.entries(languages).map(([code, { label }]) => (
        <option key={code} value={code}>{label}</option>
      ))}
    </select>
  );
}
